<script setup>
import {defineProps, defineModel, computed, onMounted, watchEffect} from 'vue';
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
    label: String,
    autocomplete: {
        type: String,
        default: 'off'
    },
    items: {
        type: Array,
        default: () => [],
    },
    itemTitle: {
        type: String,
        default: 'name',
    },
    maxlength: {
        type: Number,
        default: 80
    },
    rules: {
        type: Array,
        default: () => []
    },
    readonly: {
        type: Boolean,
        default: false
    },
    required: {
        type: Boolean,
        default: false
    },
    baseTranslate: {
        type: String,
        default: 'components.settings.permissionManagement.menuList.'
    }
});

const model = defineModel();

const requiredRule = (v) =>
    !!v || t('common.messages.validations.required')


const combinedRules = computed(() => {
    const rules = [...props.rules]
    if (props.required) rules.unshift(requiredRule)
    return rules
})


function getTranslatedTitle(item) {
    return t(props.baseTranslate + item.name);
}

</script>
<template>
    <div>
        <v-treeview
            v-model:selected="model"
            :readonly="readonly"
            :items="items"
            :item-title="(item) => getTranslatedTitle(item)"
            item-value="id"
            item-children="children"
            selectable
            select-strategy="classic"
            indeterminate-icon="mdi-minus-box"
            selected-icon="mdi-checkbox-marked"
            unselected-icon="mdi-checkbox-blank-outline"
            density="compact"
            open-on-click
            class="permission-tree"
        />
    </div>
</template>

